import React, { useEffect } from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const AdmissionProcess = () => {
  useEffect(() => {
    // Set the page title
    document.title = "Admission Process- Lotus Valley Greater Noida"; // Change 'Your Website Name' to your actual website name
  }, []);
  return (
    <>
      <HeadTag title="Admission Process" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
                {" "}
                Admission <i className="fas fa-angle-right"></i> Admission
                Process{" "}
              </span>
            </h5>
            <h2> Admission Process</h2>
          </div>
          <div className="row">


            <div className="col-lg-8 col-md-12">
              <h3>REGISTRATION</h3>

              <ul>
                <li>
                  Parents can see the form on the website{" "}
                  <b>
                    <Link to="https://www.lviscampuscare.net/">
                      www.lviscampuscare.net
                    </Link>
                  </b>
                  . Please fill up the form and submit it online only.
                </li>

                <li>Incomplete registration form will not be processed.</li>

                <li>
                  On completion of the online registration, parents will be intimated for
                  further admission process through mail within 7-10 working days. Please
                  check your mail inbox regularly.
                </li>

                <li>Parents will be notified about the admission through e-mail.</li>

                <li>
                  Once the admission is confirmed the fee has to be deposited within the
                  stipulated time period.
                </li>

                <li>
                  <b>Mandatory Documents</b> required for the final admission process
                  includes submission of self-attested copy of:
                  <ul>
                    <li>1. Birth Certificate</li>
                    <li>2. Immunization Chart</li>
                    <li>3. Aadhar Card of the child</li>
                    <li>4. Aadhar Card of both parents</li>
                    <li>5. Final Report Card (Grade II upwards)</li>
                    <li>6. Category Certificate (if applicable)</li>
                    <li>
                      7. TC original (Grade II upwards) to be submitted within one month on
                      the completion of current academic session
                    </li>
                    <li>8. PEN (Permanent Education Number)</li>
                    <li>
                      9. Passport Size Photo (4 photographs each of both parents and child)
                    </li>
                    <li>
                      10. 02 Passport Size Photo of Guardian apart from parent (maximum
                      details of 2 people)
                    </li>
                  </ul>
                </li>
              </ul>
            </div>



            <div className="col-lg-4 col-md-12">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/adm.jpg"
                  className="img-fluid"
                  alt="Lotus Valley International School, Greater Noida"
                />
              </LazyLoad>
              {/* <h3>
                Click on below Download Button to download the Registration Form
              </h3>

              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/pdf/Registration-Form.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/download.png"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>{" "}
              </Link> */}
            </div>


          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdmissionProcess;
